const svgContainer = document.querySelector("[data-image-svg]")
if($(".header-image-container").hasClass("rental"))
    var testing = document.querySelector("[data-image-svg]").children
var spanVals = $("[data-image-container]").text().split('')
var count = 0
var initialXPos = []
let policyModalOriginal
let previousActiveElement

$("[data-image-container]").text("")

for(var i = 0; i < spanVals.length; i++) {
    if($(".header-image-container").hasClass("rental"))
    { 
        if(spanVals[i] == " ")
            var span = $(`<text class="letter-${i}" dy="0.4em">`).addClass("space letter").text(spanVals[i]);
        else if(i >= 0 && i < 7) {
            var span = $(`<text class="letter-${i}" dy="0.4em">`).addClass("connect letter-bold letter").text(spanVals[i])
        } else {
            var span = $(`<text class="letter-${i}" dy="0.4em">`).addClass("connect letter").text(spanVals[i])
            count++
        }
    } else {
        if(spanVals[i] == " ")
            var span = $('<span>').addClass("space letter").text(spanVals[i]);
        else if(i >= 0 && i < 7) {
            var span = $('<span>').addClass("connect letter-bold letter").text(spanVals[i])
        } else {
            var span = $('<span>').addClass("connect letter").text(spanVals[i])
            count++
        }
    }
    
    if($(".header-image-container").hasClass("rental")) {
        $(".header-image-container svg").append(span)
        if(i == spanVals.length - 1)
            $("[data-image-container]").remove()
    } else {
        $("[data-image-container]").append(span)
    }
}

window.addEventListener("resize", () => {
    updateLetterSpacing()
    Array.from(testing).forEach((item, idx) => {
        item.style.transition = "none"
        item.style.transform = `${initialXPos[idx]}`
    })
})

if($(".header-image-container").hasClass("rental")) {
    svgContainer.addEventListener("load", () => {
        updateLetterSpacing()
        Array.from(testing).forEach((item, idx) => {
            item.style.transition = `transform 0.5s ${idx*0.05}s ease-in-out, opacity 0.5s ${idx*0.05}s ease-in-out`
            setTimeout(() => {
                item.style.transform = `${initialXPos[idx]}`
                item.style.opacity = "1"
            }, idx*0.05*1000)
        })
    })

    const rentalPolicyBtns = document.querySelectorAll("[data-rental-policy-btn]")
    policyModalOriginal = document.querySelector("[data-policy-information]").innerHTML
    
    rentalPolicyBtns.forEach(button => {
        button.addEventListener("click", () => {
            previousActiveElement = button
            openModal();
        })
    })
}

function updateLetterSpacing() {
    if($(".header-image-container").hasClass("rental")) {
        if($(".header-image-container").hasClass("rental")) {
            $(".header-image-container.rental").html($(".header-image-container.rental").html())
            testing = document.querySelector("[data-image-svg]").children
        }
        var translateDx = 0
        var widthArr = []
        var leftMargin = 15
        if(screenWidth <= 1200)
            leftMargin = 0.0214*screenWidth - 10.714
        
        Array.from(testing).forEach(item => {
            widthArr.push(item.getBoundingClientRect().width)
        })
        
        initialXPos = []
        Array.from(testing).forEach((item,idx) => {
            if(screenWidth) {
                if(screenWidth < 1600)
                    var spacingValue = -0.0844*screenWidth + 139
                else 
                    var spacingValue = 4
            }
            if(idx != 0) {
                if(widthArr[idx - 1] == 0)
                    spacingValue = 24

                translateDx = translateDx + widthArr[idx - 1] + spacingValue
                initialXPos.push(`translate(calc(${leftMargin}% + ${translateDx}px), 50%)`)
            } else {
                initialXPos.push(`translate(${leftMargin}%, 50%)`)
            }
        })
    }
}

if(!$(".header-image-container").hasClass("rental")) {
    var letters = document.querySelectorAll(".letter")
    letters.forEach((letter, idx) => {
        letter.style.transition = `transform 0.5s ${idx*0.05}s ease-in-out, opacity 0.5s ${idx*0.05}s ease-in-out`
        setTimeout(() => {
            letter.classList.add("slide-in")
        }, idx*0.05*1000)
    })
}

function openModal() {
    $.get(`/pages/rental-policy`, function(data) {
        var dataHTML = $(data).find("[data-policy-information]").html()
        $("[data-policy-information]").html(policyModalOriginal)
        $("[data-policy-modal-container]").prepend($('<div class="policy-modal-content" tabindex="0" data-modal-content>').html(dataHTML))
        var modal = document.querySelector("[data-policy-modal-wrapper]")
        modal.classList.remove("hidden")
        document.body.classList.add("no-scroll")
        setTimeout(() => {
            modal.classList.add("open")
            modal.classList.add("backdrop")
        }, 100)
        resetModalBtns()
        var temp = document.querySelector("[data-modal-content]")
        temp.focus()
    })
}

function resetModalBtns() {
    policyButtons = document.querySelectorAll("[data-policy-modal-btn]")
    policyButtons.forEach(button => {
        var btnName = button.getAttribute("data-policy-modal-btn")
        button.addEventListener("click", () => {
            if(btnName === "close") {
                var modal = document.querySelector("[data-policy-modal-wrapper]")
                modal.classList.remove("open")
                modal.classList.remove("backdrop")
                document.body.classList.remove("no-scroll")
                setTimeout(() => {
                    modal.classList.add("hidden")
                }, 500)
            }
            if(previousActiveElement)
                previousActiveElement.focus() 
        })
    })
}
